import React, {useState} from 'react';

const socialLinkStyle = {
	display: 'inline-flex',
	alignItems: 'center',
	color: '#007bff',
	textDecoration: 'none',
	verticalAlign: 'middle',
	direction: 'ltr',
};

const handleStyle = {
	marginLeft: '4px',
	whiteSpace: 'nowrap',
};

const getSocialHandle = (url) => {
	const value = (url || '').trim();

	if (value === '') {
		return '';
	}

	const withoutProtocol = value
			.replace(/^https?:+\/+/i, '')
			.replace(/^www\./i, '');
	const withoutQuery = withoutProtocol.split(/[?#]/)[0];
	const parts = withoutQuery.split('/').filter(Boolean);

	if (parts.length === 0) {
		return '';
	}

	if (parts[0].indexOf('.') !== -1) {
		return parts.length > 1 ? parts.slice(1).join('/') : '';
	}

	return parts.join('/');
};

const SocialLink = ({href, icon, alt, width}) => {
	const [hovered, setHovered] = useState(false);
	const handle = getSocialHandle(href);

	return (
			<a
					style={{...socialLinkStyle, textDecoration: hovered ? 'underline' : 'none'}}
					target="_blank"
					rel="noopener noreferrer"
					href={href}
					onMouseEnter={() => setHovered(true)}
					onMouseLeave={() => setHovered(false)}
			>
				<img style={{width}} src={icon} alt={alt}/>
				{handle !== '' && <span style={handleStyle}>{handle}</span>}
			</a>
	);
};

export default SocialLink;
